import React from "react"
import styled from "styled-components"

export default function Error ({ error, resetErrorBoundary }) {
    return (
        <FullPage>
            <ErrorCard>
                <Title>
                    🚨 오류가 발생했어요. 🙇
                    <br />
                    아래 내용을 제보해주시면 큰 도움이 됩니다.
                </Title>
                <Contact>From. 개발팀 Alex</Contact>
                <CodeBlock>{error?.message || "-"}</CodeBlock>
            </ErrorCard>
        </FullPage>
    )
}

const FullPage = styled.div`
    display: grid;
    justify-content: center;
    align-content: center;
    min-height: 100vh;
    padding: 20px;
    background-color: #f9f9f9;
    overflow-y: auto;
`

const ErrorCard = styled.div`
    text-align: center;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-width: 360px;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
`

const Title = styled.p`
    font-size: 1.15rem;
    color: #333;
    line-height: 2.1rem;
    letter-spacing: 0.01rem;
`

const Contact = styled.div`
    margin: 10px 0 20px 0;
    font-size: 1.2rem;
    font-weight: 600;
`

const CodeBlock = styled.pre`
    overflow-x: auto;
    padding: 15px;
    color: #444444;
    background: #f5f5f5;
    border-radius: 6px;
    font-size: 1rem;
    line-height: 2rem;
    letter-spacing: 0.05rem;
`